import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6 pt-3" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = {
  class: "rounded-2xl border border-gray-lp-1400 overflow-y-auto overflow-x-hidden",
  style: {"max-height":"70vh"}
}
const _hoisted_4 = { class: "min-w-full border-collapse text-black-lp-100 text-sm relative" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", { class: "bg-gray-lp-1000 sticky top-0 z-10" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left font-bold" }, " No "),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left font-bold" }, " Nomor STT "),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left font-bold" }, " Order ID "),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left font-bold" }, " Estimasi Pengiriman "),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left font-bold" }, " Jenis Pengiriman "),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left font-bold" }, " Penerima ")
  ])
], -1)
const _hoisted_6 = { class: "border-t border-gray-lp-1400" }
const _hoisted_7 = { class: "px-3 py-3 text-left" }
const _hoisted_8 = { class: "px-3 py-3 text-left font-bold text-red-lp-100" }
const _hoisted_9 = { class: "px-3 py-3 text-left" }
const _hoisted_10 = { class: "px-3 py-3 text-left" }
const _hoisted_11 = { class: "px-3 py-3 text-left" }
const _hoisted_12 = { class: "inline-block rounded-md bg-gray-lp-200 px-3 py-1 font-medium text-black-lp-300" }
const _hoisted_13 = { class: "px-3 py-3 text-left" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: _ctx.modalData.title,
        message: _ctx.modalData.message,
        image: _ctx.modalData.image,
        textSuccess: _ctx.modalData.textSuccess,
        onSubmit: _ctx.modalData.onSubmit,
        textCancel: _ctx.modalData.textCancel,
        onClose: _ctx.modalData.onClose,
        customWidth: "708px",
        customWrapperButton: "w-full",
        isButtonFull: ""
      }, {
        custom: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _createVNode("table", _hoisted_4, [
                _hoisted_5,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                  return (_openBlock(), _createBlock("tbody", {
                    key: index,
                    class: "bg-white"
                  }, [
                    _createVNode("tr", _hoisted_6, [
                      _createVNode("td", _hoisted_7, _toDisplayString(index + 1), 1),
                      _createVNode("td", _hoisted_8, _toDisplayString(item.sttNumber || "-"), 1),
                      _createVNode("td", _hoisted_9, _toDisplayString(item.data?.sttShipmentId || "-"), 1),
                      _createVNode("td", _hoisted_10, _toDisplayString(_ctx.formatEstimation(item.data?.estimationDate)), 1),
                      _createVNode("td", _hoisted_11, [
                        _createVNode("span", _hoisted_12, _toDisplayString(item.data?.sttProductType), 1)
                      ]),
                      _createVNode("td", _hoisted_13, _toDisplayString(item.data?.sttRecipientName), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_14
          ])
        ]),
        _: 1
      }, 8, ["title", "message", "image", "textSuccess", "onSubmit", "textCancel", "onClose"]))
    : _createCommentVNode("", true)
}